import React from 'react'
import style from 'styled-components'
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

export const Button = style.button`
    width:200px;
    height:50px;
    align-self:center;
    margin:1.0rem;
    background:${(props)=> props.Color};
    border:none;
    font-size:${({ theme }) => theme.fontSizes.small};
    &:hover{
       cursor:pointer;
       outline:none;
       opacity:0.8;
     }
    &:focus{
       outline:none;
     }
`;


export const LinkButton = style(Link)`
width:190px;
height:20px;
margin:1.0rem;
padding:1.0rem;
text-decoration:none;
color:white;
text-align:center;
background:${(props)=> props.Color};
font-size:${({ theme }) => theme.fontSizes.small};
&:hover{
   cursor:pointer;
   outline:none;
   opacity:0.8;
 }
&:focus{
   outline:none;
 }
`;


export default function index({onClick,ty,children,color}) {
    return (
        <>
           {ty === "submit" ?(
            <Button Color={color} type={ty} onClick={onClick}>{children}</Button>
           ):(
               <LinkButton Color={color} to={ty}>{children}</LinkButton>
           )}
        </>
    )
}


Button.propTypes = {
    onClick: PropTypes.func,
    ty: PropTypes.string,
    children:PropTypes.string,
    color:PropTypes.string
};
